// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_9471ea3","menu":"_c4f5f11","option":"_6c0da4a"};